import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = { class: "filter-box" }
const _hoisted_9 = { class: "filter-box" }
const _hoisted_10 = { class: "filter-box" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "dialog-footer mt-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isFilterCollapse)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "label" }, "订单编号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.no) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "label" }, "客户单号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.customerNo,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.customerNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "公司抬头", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.titleId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.titleId) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"]),
                  clearable: "",
                  remote: "",
                  "remote-method": _ctx.getTitleOptionRemote,
                  size: _ctx.t('table.btnSize')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titleOption, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onKeyup", "remote-method", "size"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "label" }, "客户公司", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.customerCompany,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.customerCompany) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "label" }, "制单人", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.originator,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.originator) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "label" }, "开始日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.startTime,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"]),
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onKeyup", "size"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "结束日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.endTime,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"]),
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onKeyup", "size"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isFilterCollapse = !_ctx.isFilterCollapse))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isFilterCollapse ? '展开' : '收起'), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_waves]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[21] || (_cache[21] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", {
            class: "svg-icon cursor",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleCommand('column')))
          }, [...(_cache[22] || (_cache[22] = [
            _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
          ]))])
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_TableList, {
        ref: "tableListRef",
        dataList: _ctx.list,
        columnAllData: _ctx.columnAllData,
        tableName: _ctx.TableName,
        permissionName: _ctx.permissionName,
        isShowPagination: false,
        canRefresh: false,
        canChangeColumn: false,
        onCommandChange: _ctx.handleCommand,
        highlightCurrentRow: true
      }, {
        "operation-action": _withCtx((scope) => [
          _withDirectives((_openBlock(), _createBlock(_component_el_link, {
            href: "javascript:void(0);",
            class: "mr-10",
            type: "primary",
            onClick: ($event: any) => (_ctx.handleCommand('edit', scope.row))
          }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
              _createTextVNode(" 审批 ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_APPROVAL` }]
          ])
        ]),
        _: 1
      }, 8, ["dataList", "columnAllData", "tableName", "permissionName", "onCommandChange"])), [
        [_directive_loading, _ctx.listLoading]
      ]),
      _withDirectives(_createVNode(_component_el_pagination, {
        class: "mt-20",
        total: _ctx.total,
        currentPage: _ctx.listQuery.page,
        "onUpdate:currentPage": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.listQuery.page) = $event)),
        "page-size": _ctx.listQuery.size,
        "page-sizes": _ctx.pageSizes,
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        layout: "total, sizes, prev, pager, next"
      }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
        [_vShow, _ctx.total > 0]
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_FormComponent, {
            id: _ctx.activeId,
            initFormData: _ctx.initFormData,
            fromFieldData: _ctx.originFromFieldData,
            dialogFormVisible: _ctx.dialogFormVisible,
            api: 'order',
            isShowCloseBtn: false,
            isShowSubmitBtn: false,
            marketingFee: true,
            mode: "approval",
            formDisabled: true
          }, null, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible"]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_button, {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.dialogFormVisible = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              loading: _ctx.submitLoading,
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleSubmit('approve')))
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createTextVNode(" 通过 ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_el_button, {
              type: "danger",
              loading: _ctx.submitLoading,
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleSubmit('reject')))
            }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                _createTextVNode(" 拒绝 ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}